import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AccountShell } from "@/components/account/account-shell";

export const Route = createFileRoute("/_authenticated/_account")({
  component: () => (
    <AccountShell>
      <Outlet />
    </AccountShell>
  ),
});
